import { useState, useEffect } from "react";

import { useCurrentCampaign } from "hooks/api/use-campaigns";
import { useCurrentClient } from "hooks/api/use-clients";

import type { TouchpointVersionAttributes } from "hooks/api/use-touchpoint-versions";
import { getTouchpointVersion } from "generated/api/touchpoint-version";
import type { LinkDTO } from "generated/schemas";

const touchpointVersionApi = getTouchpointVersion();

export const useTouchpointLinks = (
  touchpointId: string,
  selectedVersion?: TouchpointVersionAttributes,
) => {
  const currentClient = useCurrentClient();
  const currentCampaign = useCurrentCampaign();
  const [links, setLinks] = useState<LinkDTO[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const fetchLinks = async () => {
      if (!selectedVersion) {
        setLinks([]);
        return;
      }

      setIsLoading(true);

      try {
        const extractedLinks = await touchpointVersionApi.extractLinksFromFinalHtml({
          clientId: currentClient.id,
          campaignId: currentCampaign.id,
          touchpointId,
          versionId: selectedVersion.id,
        });
        setLinks(extractedLinks);
      } catch (err) {
        console.error("Error fetching links:", err);
        setLinks([]);
      } finally {
        setIsLoading(false);
      }
    };

    fetchLinks();
  }, [selectedVersion, currentClient.id, currentCampaign.id, touchpointId]);

  return { links, isLoading };
};
